import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { getAccount } from "Redux/Actions/GetAccountAction";

import AppConstants from "Constants/AppConstants";

import { getProductFromVault } from "Components/MarketPlace/Action/MarketPlaceAction";
import withApplicantHOC from "Hoc/ApplicantHOC/ApplicantHOC";
import BusinessOperations from "./BusinessOperations";
import withBusinessHOC from "../../Hoc/BusinessHOC";
import { HTTP_STATUS } from "../../Communication/Constants";

class BusinessOperationsContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    console.log("componentDidMount");
    const { doGetApplicationProperty, getActiveProduct, products } = this.props;
    const activeProduct = getActiveProduct(products);
    doGetApplicationProperty({ applicationId: activeProduct.applicationId });
  }

  handleChange = () => {};

  handleContinue = (data) => {
    console.log("handleContinue", data);
    const { continuehandler, doUpdateApplicant, applicantData } = this.props;
    doUpdateApplicant(data.applicant, applicantData.id, (res) => {
      console.log(res);
      if (res.status === HTTP_STATUS.OK) {
        continuehandler(
          data.vault,
          AppConstants.APPLICATIONSTEP.BUSINESS_OPERATIONS
        );
      }
    });
  };

  render() {
    const {
      getDataFromServer,
      handleBack,
      steps,
      activeStepID,
      products,
      getActiveProduct,
      finInfo,
      applicantData,
    } = this.props;

    const activeProduct = getActiveProduct(products);

    return (
      <>
        <BusinessOperations
          handleContinue={this.handleContinue}
          handleChange={this.handleChange}
          getDataFromServer={getDataFromServer}
          handleBack={handleBack}
          steps={steps}
          activeStepID={activeStepID}
          activeProduct={activeProduct}
          finInfo={finInfo}
          applicantData={applicantData}
        />
      </>
    );
  }
}

BusinessOperationsContainer.propTypes = {
  getDataFromServer: PropTypes.func.isRequired,
  continuehandler: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired,
  steps: PropTypes.arrayOf(PropTypes.object),
  activeStepID: PropTypes.number,
};

BusinessOperationsContainer.defaultProps = {
  steps: [],
  activeStepID: -1,
  finInfo: {},
};

const mapStateToProps = (state) => ({
  MemberExists: state.MemberExistsReducer,
  products: state.VaultReducer.vaultProductList,
  provinceList: state.AboutYouReducer.provinceList,
  actionBack: state.ApplicationReducer.actionBack,
  streetTypes: state.LoanDetailsReducer.streetTypes,
  finInfo: state.MarketplaceReducer.finInfo,
  applicantData: state.ApplicationReducer.response,
});

const mapDispatchToProps = (dispatch) => {
  return {
    doGetAcoountDetails: (callback) => dispatch(getAccount(callback)),
    doGetProductFromVault: (callback) =>
      dispatch(getProductFromVault(callback)),
  };
};

// export default connect(mapStateToProps, mapDispatchToProps)(BusinessOperationsContainer);

const BusinessOperationsWrapper = withBusinessHOC(BusinessOperationsContainer);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BusinessOperationsWrapper);
